import React, {useEffect, useState} from 'react';
import {
    Box,
} from "@material-ui/core";
import RenderInput from "./RenderInput";

const PayoutStrategyInput = ({item, disabled, value, handleFilterChange, handleSwitchChange, handleInputChange, data, setInputs, inputs}) => {
    const [strategy, setStrategy] = useState([]);
    const [selectedStrategy, setSelectedStrategy] = useState({
        strategy: '',
        activePrice: '',
        prices: '',
        value
    });

    useEffect(() => {
        if (data) {
            let strategyArr = [];
            //Set None Price Strategies
            strategyArr = data.allAffiliatePayoutStrategy.nodes.filter(ps => ps.enum.includes('DOG_STAR_FLAT_RATE') || (!ps.enum.includes('FLEX') && !ps.enum.includes('DIRECT_LENDER') && !ps.enum.includes('CLASSIC') && !ps.enum.includes('CLASSIC_NO_MIN') && !ps.enum.includes('FLAT_RATE') && !ps.enum.includes('PLX_OP') ) ? ps : null);

            strategyArr = strategyArr.map(item => ({
                ...item,
                prices: []
            }));
            //Set Flex Price Strategies
            strategyArr.push(setPriceStrategies('FLEX', 'default-FLEX', 1));
            //Set Flex Lite Price Strategies
            strategyArr.push(setPriceStrategies('FLEX_LITE', 'flexlite', 2));
            //Set Static Price Strategies
            strategyArr.push(setPriceStrategies('STATIC', 'direct_lender_set_price', 4));
            //Set Classic No Min Price Strategies
            strategyArr.push(setPriceStrategies('CLASSIC_NO_MIN', 'classic-no-min', 3));
            //Set Classic Price Strategies
            strategyArr.push(setPriceStrategies('CLASSIC', 'classic', 1));
            //Set Snake Flex Strategies
            strategyArr.push(setPriceStrategies('SNAKE_FLEX', 'snakeflex', 2));
            // Set Flex Target
            strategyArr.push(setPriceStrategies('FLEX_TARGET', 'flextarget', 2));
            // Set Flat Rate Target
            strategyArr.push(setPriceStrategies('FLAT_RATE', 'flatrate', 2));
            // Set Flat Rate Target
            strategyArr.push(setPriceStrategies('FLEX_FLOOR', 'flexfloor', 2));
            // Set Flat Rate Target
            strategyArr.push(setPriceStrategies('PLX_OP_FLEX_FLOOR', 'pinglogix-offpeak', 4));
            // Set PLX OP
            strategyArr.push(setPriceStrategies('PLX_OP_FLEX', 'pinglogix-offpeak', 3));
            //Set Strategy
            setStrategy(strategyArr);
            //Set Selected Strategy
            if (value && (value.includes('FLEX') || value.includes('DIRECT_LENDER') || value.includes('CLASSIC') || value.includes('CLASSIC_NO_MIN') || value.includes('SNAKE_FLEX') || (value.includes('FLAT') || (value.includes('PLX_OP') && !value.includes("DOG_STAR"))))) {
                const obj = setActiveStrategies(value, strategyArr);
                setSelectedStrategy({
                    ...obj,
                });
            } else {
                setSelectedStrategy({
                    strategy: value,
                    activePrice: '',
                    prices: '',
                    value
                })
            }
        }
    }, [data]);

    useEffect(() => {
        const inputPayoutStrategy = inputs['payoutStrategy']

        if (selectedStrategy && inputPayoutStrategy !== selectedStrategy.strategy) {
            setInputs({
                ...inputs,
                [item.key]: selectedStrategy.value || ''
            });
        }
    }, [selectedStrategy])

    useEffect(() => {
        const inputPayoutStrategy = inputs['payoutStrategy']
        if(inputPayoutStrategy && inputPayoutStrategy !== selectedStrategy.strategy){
            setSelectedStrategy({
                strategy: inputPayoutStrategy,
                activePrice: '',
                prices: '',
                value: inputPayoutStrategy
            })
        }
    }, [inputs])

    const checkIfCents = (price) => price.findIndex(x => x === 'CENT' || x === 'CENTS');

    const setActiveStrategies = (defaultValue, arr) => {
        const valueSplit = defaultValue.split('_');
        const selectedStrategy = arr.filter(item => {
            let matched = false;
            item.prices.forEach(price => {
                if (price.enum === defaultValue) {
                   matched = true;
                }
            });
            return matched;
        });
        let obj = {
            strategy: '',
            activePrice: '',
            prices: [],
            value: defaultValue,
        };
        if (selectedStrategy.length) {
            const { name, prices, priceIndex } = selectedStrategy[0];
            let activePrice = valueSplit[priceIndex];
            if (checkIfCents(valueSplit) > 0) {
                activePrice = activePrice + ' Cents';
            }
            obj = {
                ...obj,
                strategy: name,
                activePrice,
                prices,
            };
        }
        return obj;
    };
    /**
     * @param type - FLEX OR STATIC
     * @param check - Value to check against the graphql
     * @param priceIndex - the price index position
     * @returns {{name: *, id: string, prices: *, enum: *}}
     */
    const setPriceStrategies = (type, check, priceIndex) => {
        let arr = []
        // special filtering for PLX_OP* payout strategies due to them sharing the same id for check
        if (type === "PLX_OP_FLEX_FLOOR") {
            const plxOpFlexFloorRegex = new RegExp("PLX_OP_FLEX_FLOOR_[0-9]*_PERCENT")
            arr = data.allAffiliatePayoutStrategy.nodes.filter(ps => {
                return plxOpFlexFloorRegex.test(ps.enum)
            });
        } else if (type === "PLX_OP_FLEX") {
            const plxOpFlexRegex = new RegExp("PLX_OP_FLEX_[0-9]*_PERCENT")
            arr = data.allAffiliatePayoutStrategy.nodes.filter(ps => {
                return plxOpFlexRegex.test(ps.enum)
            });
        } else {
            arr = data.allAffiliatePayoutStrategy.nodes.filter(ps => ps.id.includes(check) ? ps : null);
        }
        const priceArr = arr.map(item => {
            const price = item.enum.split('_');
            let payoutPrice = false;
            if (price.length) {
                payoutPrice = price[priceIndex];
                const payoutPriceCents = Number(price[priceIndex+1]);
                if(payoutPriceCents){
                    payoutPrice += `.${payoutPriceCents}`
                }
                if (checkIfCents(price) > 0) {
                    payoutPrice = payoutPrice + ' Cents';
                }
            }
            return {
                ...item,
                payoutPrice,
            };
        });

        return {
            id: `default-${type}`,
            priceIndex,
            enum: type,
            name: type,
            prices: priceArr,
        };
    };

    const setLabel = (label) => {
        switch (label) {
            case 'FLEX':
            case 'CLASSIC':
            case 'CLASSIC_NO_MIN':
                return 'Percentage';
            case 'STATIC':
                return 'Price';
            default:
                return '';
        }
    }
    return (
        <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDirection={"column"}
            style={{height: '200px'}}
        >
            <RenderInput
                item={{
                    ...item,
                    label: 'Strategy',
                    type: 'autoComplete',
                    displayKey: 'enum'
                }}
                value={selectedStrategy.strategy}
                data={strategy}
                handleFilterChange={(value) => {
                    if (value) {
                        setSelectedStrategy({
                            strategy: value.enum,
                            activePrice: '',
                            prices: value.prices.length ? value.prices : '',
                            value: !value.prices.length ? value.enum : null
                        })
                    } else if (!value) {
                        setSelectedStrategy({
                            strategy: '',
                            activePrice: '',
                            prices: '',
                            value: ''
                        });
                    }
                }}
                handleInputChange={handleInputChange}
                handleSwitchChange={handleSwitchChange}
            />
            <RenderInput
                item={{
                    ...item,
                    label: setLabel(selectedStrategy.strategy),
                    type: 'autoComplete',
                    required: false,
                    displayKey: 'payoutPrice'
                }}
                value={selectedStrategy.activePrice}
                data={selectedStrategy.prices}
                handleFilterChange={(value) => {
                    if (value) {
                        setSelectedStrategy(prevState => ({
                            ...prevState,
                            activePrice: value.payoutPrice,
                            value: value.payoutPrice.length ? value.enum : null
                        }));
                    } else if (!value) {
                        setSelectedStrategy(prevState => ({
                            ...prevState,
                            activePrice: '',
                            value: ''
                        }));
                    }
                }}
                disabled={selectedStrategy.prices === ''}
                handleInputChange={handleInputChange}
                handleSwitchChange={handleSwitchChange}
            />
            <RenderInput
                item={{
                    ...item,
                    label: 'Final Payout Strategy',
                    type: 'text'
                }}
                value={selectedStrategy.value || ''}
                data={data}
                readOnly={true}
                handleFilterChange={handleFilterChange}
                handleInputChange={handleInputChange}
                handleSwitchChange={handleSwitchChange}
            />
        </Box>
    );
};

export default PayoutStrategyInput;
